<template>
    <div v-if="basicConf.overflowX" :style="bgstyle">
        <webp-img :src="imgUrl || basicConf.url" :style="style" class="mars-image" />
    </div>
    <div v-else-if="basicConf.showGauss" class="gradual-image">
        <webp-img
        :class="['original-image']"
        :src="imgUrl || basicConf.url"
        @load="isSuccess = true"
        />
        <webp-img v-if="gaussImage" :class="['guass-img', isSuccess && 'success-image']" :src="gaussImage" />
    </div>
    <webp-img v-else :src="imgUrl || basicConf.url" :style="style" class="mars-image" />
</template>
<script>
export default {
    name: 'MarsImage',
    props: {
        editableData: {
            type: Object,
            default: function() {
                return {
                    basic: {}
                }
            }
        }
    },
    data() {
        return {
            imgUrl: '',
            isSuccess: false
        }
    },
    computed: {
        basicConf: function() {
            return this.editableData.basic
        },
        // style: function() {
        //     return {
        //         'object-fit': this.basicConf.size,
        //         'vertical-align': 'middle'
        //     }
        // }
        style: function() {
            if (this.basicConf.overflowX) {
                return {
                    'width': 'auto',
                    'height': '100%'
                }
            }
            return {
                'object-fit': this.basicConf.size,
                'vertical-align': 'middle'
            }
        },
        bgstyle: function() {
            if (this.basicConf.overflowX) {
                return {
                    'overflow-x': 'scroll',
                    'height': '100%',
                    'width': '100%'
                }
            }
            return {}
        },
        // eslint-disable-next-line vue/return-in-computed-property
        gaussImage: function() {
            const url = this.imgUrl || this.basicConf.url
            let gauss = ''
            if (url) {
                gauss = 'https://web-static.didachuxing.com/pics/' + url.split('pics/').pop()
                return gauss.replace(/\.(jpg|png|gif)/, '_gauss.webp')
            }
        }
    },
    methods: {
        changeImage(value) {
            let obj = value.url
            if (this.basicConf.imgKey) {
                const keys = this.basicConf.imgKey.split('.')
                while (keys.length > 0) {
                    const key = keys.shift()
                    if (obj[key]) {
                        obj = obj[key]
                    } else {
                        return this.imgUrl = value.url
                    }
                }
            }
            return this.imgUrl = obj
        }
    }
}
</script>
  
<style lang="scss">
    @import './../webp.scss';
    .mars-image{
        width: 100%;
        height: 100%;
        display: block;
    }
</style>
<style lang="scss" scoped>
.gradual-image {
position: relative;
img {
    width: 100%;
    height: 100%;
    display: block;
}
.guass-img {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 1;
}
}
.gradual-image {
.success-image {
    opacity: 0;
    }
}
</style>
  
  